import { Shield, Radio } from "lucide-react";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const SOCIAL_PLATFORMS = [
  { key: 'instagram', label: 'Instagram', icon: (
    <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
  )},
  { key: 'twitter', label: 'X (Twitter)', icon: (
    <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
  )},
  { key: 'facebook', label: 'Facebook', icon: (
    <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
  )},
  { key: 'youtube', label: 'YouTube', icon: (
    <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5"><path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>
  )},
  { key: 'tiktok', label: 'TikTok', icon: (
    <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5"><path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/></svg>
  )},
];

const Footer = () => {
  const [socialLinks, setSocialLinks] = useState({});
  const [businessInfo, setBusinessInfo] = useState({});

  useEffect(() => {
    fetch(`${BACKEND_URL}/api/public/social-links`)
      .then(r => r.ok ? r.json() : {})
      .then(data => setSocialLinks(data))
      .catch(() => {});
    fetch(`${BACKEND_URL}/api/public/business-info`)
      .then(r => r.ok ? r.json() : {})
      .then(data => setBusinessInfo(data))
      .catch(() => {});
  }, []);

  const activeSocials = SOCIAL_PLATFORMS.filter(p => socialLinks[p.key]);
  const hasAddress = businessInfo.name || businessInfo.address;
  const addressLine = [businessInfo.address, businessInfo.city, businessInfo.state, businessInfo.zip].filter(Boolean).join(', ');

  return (
    <footer className="py-12 bg-[#08080f] border-t border-white/10" data-testid="footer">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="flex items-center flex-shrink-0">
            <img src="/logo-header.png" alt="DJsandMCMedia" className="w-60 object-contain" />
          </div>
          <div className="flex flex-wrap justify-center gap-6 text-white/50 text-sm">
            <a href="#home" className="hover:text-white transition">Home</a>
            <a href="#features" className="hover:text-white transition">Features</a>
            <a href="#pricing" className="hover:text-white transition">Pricing</a>
            <a href="#contact" className="hover:text-white transition">Contact</a>
            <Link to="/terms" className="hover:text-white transition" data-testid="footer-terms-link">Terms of Use</Link>
            <Link to="/submission-terms" className="hover:text-white transition" data-testid="footer-submission-terms-link">Submission Terms</Link>
            <Link to="/dmca" className="hover:text-white transition" data-testid="footer-dmca-link">DMCA</Link>
            <Link to="/privacy" className="hover:text-white transition" data-testid="footer-privacy-link">Privacy</Link>
            <Link to="/guide" className="hover:text-white transition" data-testid="footer-guide-link">Setup Guide</Link>
            <Link to="/shop" className="hover:text-white transition" data-testid="footer-shop-link">Shop</Link>
            <Link to="/network" className="hover:text-white transition" data-testid="footer-showcase-link">Showcase</Link>
            <Link to="/why-us" className="hover:text-white transition" data-testid="footer-whyus-link">Why Us</Link>
            <Link to="/news" className="hover:text-white transition" data-testid="footer-news-link">News</Link>
            <Link to="/discover" className="hover:text-white transition" data-testid="footer-discover-link">Discover</Link>
          </div>
        </div>

        {/* Social Media Icons */}
        {activeSocials.length > 0 && (
          <div className="flex justify-center gap-4 mt-8" data-testid="footer-social-links">
            {activeSocials.map(platform => (
              <a
                key={platform.key}
                href={socialLinks[platform.key]}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-white/40 hover:text-white hover:bg-purple-500/20 hover:border-purple-500/40 transition-all duration-300"
                data-testid={`footer-social-${platform.key}`}
                title={platform.label}
              >
                {platform.icon}
              </a>
            ))}
          </div>
        )}

        <div className="flex items-center justify-center mt-6">
          <p className="text-white/40 text-sm">© 2026 DJsandMCMedia™. All rights reserved.</p>
        </div>
        {/* DMCA Badge */}
        <div className="flex flex-col items-center gap-3 mt-6">
          <p className="text-white/40 text-xs flex items-center gap-1.5" data-testid="footer-licensed-line">
            <Radio size={12} className="text-green-400" />
            DJsandMCMedia operates as a licensed internet radio platform.
          </p>
          <Link to="/dmca" data-testid="footer-dmca-badge" className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10 hover:border-purple-500/30 transition text-white/40 hover:text-white/60 text-xs">
            <Shield size={14} className="text-purple-400" />
            DMCA Protected — DMCA-1070621
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
